/**
 * Регистрация протокола pmtiles:// в MapLibre.
 *
 * MapLibre умеет запрашивать тайлы только по шаблону {z}/{x}/{y}. Протокол
 * перехватывает такие запросы, вычисляет по внутреннему индексу PMTiles нужный
 * диапазон байт и забирает его одним HTTP Range-запросом. Именно поэтому весь
 * слой лежит одним файлом на обычной статике, без тайлового сервера.
 */

import { addProtocol } from "maplibre-gl";
import { Protocol } from "pmtiles";

let protocol: Protocol | null = null;

export function registerPMTilesProtocol(): Protocol {
  if (protocol) return protocol;
  protocol = new Protocol();
  addProtocol("pmtiles", protocol.tile);
  return protocol;
}
